import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import { Modal } from "react-bootstrap";
import { InputLabelAlert } from "../../../layout";
import { uriList } from "../../../../helpers/config";
import { sendData } from "../../../../helpers/auth";
import { connect } from "react-redux";

const Form = ({ ...props }) => {
    const [codigo, setCodigo] = useState("");
    const [warning, setWarning] = useState(0);

    useEffect(() => {
        console.log("gravarToken.useEffect: ", props.detalhes.uuid, props.proposta)
    }, []);

    const handleChange = (e) => {
        let target = e.currentTarget;
        let value = target.value;
        value = value.toUpperCase().trim();
        setCodigo(value);
        setWarning(0);
    };

    const handleClose = (validado = false) => {
        setCodigo("");
        setWarning(0);
        props.onCloseEv && props.onCloseEv(validado);
    };

    const handleGravar = async () => {
        if (!codigo) {
            setWarning(1);
            return;
        }

        await sendData({
            uri: uriList("gravarToken"),
            content: {
                uuid: props.detalhes.uuid || props.proposta.uuid,
                token: codigo,
            },
            method: "POST",
        })
            .then((res) => {
                if (res.status && parseInt(res.status) > 200) throw new Error();
                handleClose(true);
            })
            .catch((e) => {
                console.log(e.message);
                console.log(e.data);
                if (e.data) console.log(e.data.message);
                alert("Erro ao enviar código!");
            });
    };

    return (
        <Modal size="sm" show={true} onHide={handleClose} centered animation={false} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    <span>{props.titulo || "Gravar Token"}</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="maxWidth750">
                <div style={{ display: "flex", flexDirection: "column", width: "100%", maxWidth: "280px", margin: "0 auto" }}>
                    <div style={{ marginBottom: "20px", width: "100%" }}>
                        <InputLabelAlert
                            type="text"
                            label="Token:"
                            id="token"
                            cifrao={false}
                            value={codigo}
                            length="10"
                            onChange={codigo}
                            handle={handleChange}
                            autoComplete="off"
                            warning={warning}
                            focus={true}
                            msgErro="Token inválido!"
                        />
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        width: '100%'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '10px',
                            width: '100%'
                        }}>
                            <Button color="success" onClick={handleGravar} style={{ minWidth: '70px', flex: '1' }}>
                                Gravar
                            </Button>
                        </div>
                        {props.onCloseEv &&
                            <Button color="secondary" onClick={() => handleClose()} style={{ minWidth: '70px', width: '100%' }}>
                                Fechar
                            </Button>}
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

function mapStateToProps(state) {
    return {
        proposta: state.dados.proposta,
        detalhes: state.dados.detalhes,
    };
}

export default connect(mapStateToProps)(Form);
